<div class="input-container">
  <input
    (focus)="onFocus()"
    (blur)="onBlur()"
    #inputField
    [autofocus]="false"
    [type]="type"
    [attr.data-testid]="
      type === 'email' ? 'VoucherPage.email' : type === undefined ? 'VoucherPage.creditCardCode' : 'VoucherPage.promoCode'
    "
    [formControl]="innerControl"
    [class.filled]="innerControl.value.length"
    [class.valid]="isInputValid || suffixIcon"
    [class.show-error]="showErrorMsg"
    [placeholder]="placeholder"
    [attr.disabled]="disabled ? true : null"
    [readonly]="readOnly"
  />
  <div *ngIf="isInputValid && validIcon" class="suffix-icon" [class.increased-icon]="increasedIconSize">
    <svg-icon
      [key]="validIcon"
      [attr.data-testid]="type === 'text' ? 'VoucherPage.promoCodeGreenTick' : 'VoucherPage.creditCardCodeGreenTick'"
    ></svg-icon>
  </div>
  <div *ngIf="!isInputValid && suffixIcon" class="suffix-icon" [class.increased-icon]="increasedIconSize">
    <svg-icon [key]="suffixIcon"></svg-icon>
  </div>
</div>
<div [@errorAnimation]="showErrorMsg ? 'invalid' : 'valid'" class="error-container">
  <p
    class="error-hint"
    [attr.data-testid]="type === 'text' ? 'VoucherPage.promoCodeErrorMessage' : 'VoucherPage.creditCardCodeErrorMessage'"
  >
    {{ gwError ?? fallbackError }}
  </p>
</div>
